import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Space, Typography } from 'antd';
import { ReadOutlined, CodeOutlined, RocketOutlined, HistoryOutlined } from '@ant-design/icons';
import { brand, glassPanelStyle } from '../theme';
import BrandLogomark from './common/BrandLogomark';

const { Text } = Typography;

const APP_VERSION = process.env.REACT_APP_VERSION || 'dev';

const AppFooter: React.FC = () => {
  const navigate = useNavigate();

  const linkStyle: React.CSSProperties = {
    fontSize: 13,
    color: '#8c8c8c',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    textDecoration: 'none',
    transition: 'color 0.15s',
  };

  return (
    <div
      style={{
        ...glassPanelStyle,
        margin: '0 12px 12px 12px',
        padding: '14px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
      }}
    >
      {/* Brand */}
      <Space align="center" size={6}>
        <BrandLogomark size={20} />
        <Text style={{ fontSize: 13, fontWeight: 700, color: '#141414' }}>{brand.name}</Text>
        <Text type="secondary" style={{ fontSize: 12 }}>by {brand.vendor}</Text>
      </Space>

      {/* Links */}
      <Space size={20}>
        <span
          style={linkStyle}
          onClick={() => navigate('/docs')}
          onMouseEnter={e => (e.currentTarget.style.color = '#1677ff')}
          onMouseLeave={e => (e.currentTarget.style.color = '#8c8c8c')}
        >
          <ReadOutlined style={{ fontSize: 12 }} />
          Documentación
        </span>
        <span
          style={linkStyle}
          onClick={() => navigate('/api-docs')}
          onMouseEnter={e => (e.currentTarget.style.color = '#1677ff')}
          onMouseLeave={e => (e.currentTarget.style.color = '#8c8c8c')}
        >
          <CodeOutlined style={{ fontSize: 12 }} />
          API Reference
        </span>
        <span
          style={linkStyle}
          onClick={() => navigate('/roadmap')}
          onMouseEnter={e => (e.currentTarget.style.color = '#1677ff')}
          onMouseLeave={e => (e.currentTarget.style.color = '#8c8c8c')}
        >
          <RocketOutlined style={{ fontSize: 12 }} />
          Roadmap
        </span>
        <span
          style={linkStyle}
          onClick={() => navigate('/changelog')}
          onMouseEnter={e => (e.currentTarget.style.color = '#1677ff')}
          onMouseLeave={e => (e.currentTarget.style.color = '#8c8c8c')}
        >
          <HistoryOutlined style={{ fontSize: 12 }} />
          Changelog
        </span>
      </Space>

      {/* Copyright + version */}
      <Space size={10}>
        <Text type="secondary" style={{ fontSize: 12 }}>
          v{APP_VERSION}
        </Text>
        <Text type="secondary" style={{ fontSize: 12 }}>
          © {new Date().getFullYear()} {brand.vendor}
        </Text>
      </Space>
    </div>
  );
};

export default AppFooter;
